// removed by extract-text-webpack-plugin
module.exports = {"form-type-classBillingMethod":"form-type-classBillingMethod","hasError":"hasError","row":"row","billing-method-container":"billing-method-container","radio":"radio"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/ClassBillingMethod/ClassBillingMethod.scss
// module id = 044t
// module chunks = 0